// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadVideoModal-modulewrapper3PG"};